import { render, staticRenderFns } from "./SaveDialog.vue?vue&type=template&id=1e6d4d38"
import script from "./SaveDialog.vue?vue&type=script&lang=js"
export * from "./SaveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports